import TagManager from 'react-gtm-module';

import PII_BLOCKLIST from './piiBlocklist';

let enabled = false;

// Recursively strips any key in PII_BLOCKLIST from an object/array, so a call
// site that carelessly spreads a bigger object into a dataLayer push can't
// leak personal data even if it forgets to shape the payload by hand.
const sanitize = (value) => {
    if (Array.isArray(value)) {
        return value.map(sanitize);
    }
    if (value && typeof value === 'object') {
        return Object.keys(value).reduce((acc, key) => {
            if (!PII_BLOCKLIST.includes(key)) acc[key] = sanitize(value[key]);
            return acc;
        }, {});
    }
    return value;
};

// Tracking is opt-in per deployment: only brands/hostnames that actually
// have a GTM container configured (see public/config.js -> ENV.GTM_ID) get
// GTM initialized and pushed to; everyone else runs the exact same code
// with tracking silently inert. There is no brand-specific logic here.
export const initTracking = (gtmId) => {
    if (!gtmId) return;
    TagManager.initialize({ gtmId });
    enabled = true;
};

export const pushEvent = (event, params = {}) => {
    if (!enabled) return;
    window.dataLayer = window.dataLayer || [];
    TagManager.dataLayer({ dataLayer: sanitize({ event, ...params }) });
};

// For the Wizard's "Pageview": no 'event' key - GTM's own built-in page view
// trigger fires on container load, it just needs these variables already
// present in the dataLayer by then.
export const pushRaw = (params = {}) => {
    if (!enabled) return;
    window.dataLayer = window.dataLayer || [];
    TagManager.dataLayer({ dataLayer: sanitize(params) });
};
